import React, { useState } from 'react';
import { Form, Input, message, Modal, Radio } from 'antd';
import { addTextContent, ITEM_KIND_OPTIONS } from '@/api/knowledgeBase';

export interface TextUploadModalProps {
  kbId: number;
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

const TextUploadModal: React.FC<TextUploadModalProps> = ({
  kbId,
  visible,
  onCancel,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async () => {
    try {
      const values = await form.validateFields();

      if (!values.content || values.content.trim() === '') {
        message.error('内容不能为空');
        return;
      }

      setLoading(true);

      const result = await addTextContent({
        kbId,
        content: values.content,
        name: values.name,
        kind: values.kind || 'rag',
      });

      if (result.kind === 'config') {
        message.success('配置条目已保存，不进行分块和向量化');
      } else if (result.kind === 'rag') {
        message.success(`添加成功，共生成 ${result.chunkCount || 0} 个分块`);
      } else {
        message.success('添加成功');
      }
      form.resetFields();
      onCancel();
      onSuccess();
    } catch (error: any) {
      message.error(error.message || '添加失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="添加文本内容"
      open={visible}
      onCancel={onCancel}
      onOk={handleFinish}
      confirmLoading={loading}
      width={600}
      maskClosable={false}
    >
      <Form form={form} layout="vertical" initialValues={{ kind: 'rag' }}>
        <Form.Item
          name="name"
          label="条目名称（可选）"
        >
          <Input placeholder="请输入条目名称，如不填写将自动生成" />
        </Form.Item>
        <Form.Item
          name="kind"
          label="条目类型"
        >
          <Radio.Group>
            {ITEM_KIND_OPTIONS.map(opt => (
              <Radio key={opt.value} value={opt.value}>{opt.label}</Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="content"
          label="文本内容"
          rules={[{ required: true, message: '请输入文本内容' }]}
        >
          <Input.TextArea
            rows={10}
            placeholder="请输入或粘贴文本内容..."
            showCount
          />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.kind !== cur.kind}>
          {({ getFieldValue }) => {
            const kind = getFieldValue('kind');
            const tip = kind === 'config'
              ? '提示：配置条目仅存储原文内容，不进行分块和向量化处理，供智能体按条目直接读取配置参数。'
              : '提示：文本将按知识库配置的分块大小进行切分，并自动生成向量索引。';
            return (
              <div style={{ color: '#666', fontSize: 12, marginTop: 8 }}>
                {tip}
              </div>
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TextUploadModal;
